/**
 * @example
 *  - ['giftCard']
 *  - ['giftCard', 'detail']
 */
export const GiftCardQueryKeys = {
  all: () => ['giftCard'] as const,
  detail: (id?: number) =>
    [
      ...GiftCardQueryKeys.all(),
      'detail',
      ...(id !== undefined ? [id] : [])
    ] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...GiftCardQueryKeys.all(),
      'giftCard',
      ...(filters ? [filters] : [])
    ] as const,
  discount: (sku: string, amount: number, quantity: number) => [
    ...GiftCardQueryKeys.all(),
    sku,
    amount,
    quantity
  ]
};
